import React from 'react';
import Slider from 'react-slick';
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SCROLL_OFFSET = 100;

const scrollToPackages = () => {
  const packageSection = document.getElementById('packagesSection');
  if (packageSection) {
    const elementPosition = packageSection.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementPosition - SCROLL_OFFSET,
      behavior: 'smooth'
    });
  }
};

const NextArrow = ({ onClick, isMobile }) => {
  const arrowSize = isMobile ? '20px' : '30px';
  const buttonDim = isMobile ? 32 : 48;
  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      sx={{
        position: 'absolute',
        right: isMobile ? '5px' : '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2,
        width: buttonDim,
        height: buttonDim,
        backgroundColor: 'white',
        color: 'black',
        '&:hover': { backgroundColor: 'white' }
      }}>
      <ArrowForwardIosIcon sx={{ fontSize: arrowSize }} />
    </IconButton>
  );
};

const PrevArrow = ({ onClick, isMobile }) => {
  const arrowSize = isMobile ? '20px' : '30px';
  const buttonDim = isMobile ? 32 : 48;
  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      sx={{
        position: 'absolute',
        left: isMobile ? '5px' : '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2,
        width: buttonDim,
        height: buttonDim,
        backgroundColor: 'white',
        color: 'black',
        '&:hover': { backgroundColor: 'white' }
      }}>
      <ArrowBackIosIcon sx={{ fontSize: arrowSize }} />
    </IconButton>
  );
};

const DynamicBanner = ({ images = [], mobileBanner = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const selectedBanners = isMobile && mobileBanner.length > 0 ? mobileBanner : images;

  if (selectedBanners.length === 0) return null;

  const sliderSettings = {
    dots: selectedBanners.length > 1,
    infinite: selectedBanners.length > 1,
    arrows: selectedBanners.length > 1,
    autoplay: selectedBanners.length > 1,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow isMobile={isMobile} />,
    prevArrow: <PrevArrow isMobile={isMobile} />
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Slider {...sliderSettings}>
        {selectedBanners.map((image, index) => (
          <Box key={`${image}-${index}`} onClick={scrollToPackages} sx={{ cursor: 'pointer' }}>
            <img
              loading={index === 0 ? 'eager' : 'lazy'}
              src={image}
              alt={`Banner ${index + 1}`}
              style={{
                width: '100%',
                display: 'block',
                height: 'auto',
                objectFit: 'cover'
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default DynamicBanner;
